<template>
  <div class="page">
    <div class="content">
      <div class="s-tab">
        <div class="s-item" v-for="(item,index) in tabList" :key="item.id" @click="handleTab(item, index)" :class="tabIndex==index?'active':''">
          {{item.name}}
        </div>
      </div>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Beautiful',
  data () {
    return {
      tabIndex: 0,
      tabList: [
        { id: 1, name: '最美九龙坡', path: '/beautifulJiulong' },
        { id: 2, name: '精彩锦集', path: '/wonderfulMoments' },
      ]
    }
  },
  mounted () {
    let routerName= this.$route.name
    if ('BeautifulJiulong' == routerName) {
      this.tabIndex = 0
    } else {
      this.tabIndex = 1
    }
  },
  methods: {
    handleTab (item, index) {
      this.tabIndex = index
      this.$router.push({
        path: item.path
      })
    },
  },
  watch: {
    $route(newValue, oldValue) {
      // console.log('routeValue', newValue, oldValue)
    }
  }
}
</script>

<style lang="scss" scoped>
  .page{
    width: 100%;
    min-height: 580px;
    background: url('https://static.daoba.com/jlpsport/beautiful_bg.jpg') no-repeat top center;
    background-size: 100% 540px;

    .content {
      width: 1200px;
      padding-top: 150px;
      margin: 0 auto;
      .s-tab{
        width:1200px;
        margin:0 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        // background: rgba(18,69,132,0.5);
        background-color: #FFFFFF;
        padding-top: 30px;
        padding-left: 30px;
        padding-bottom: 10px;
        margin-bottom: 1px;
        .s-item{
          width: 140px;
          height: 46px;
          text-align: center;
          line-height: 46px;
          margin-right: 30px;
          cursor: pointer;
          font-size: 18px;
          border-radius: 5px;
          // background-color: #ccc;
        }
        .active{
          background-color: #009EDF;
          font-size: 20px;
          color: #FFFFFF;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/district/views/beautiful/Home.vue